import React from 'react';

const RGPD = () => {
  return (
    <main className="min-h-screen">
      <div className="pt-20">
        <section className="section bg-white">
          <div className="container mx-auto max-w-4xl">
            <h1 className="heading-xl mb-8 text-gray-900">RGPD - Protection des données</h1>
            
            <div className="prose prose-lg max-w-none">
              <h2 className="heading-lg mt-8 mb-4">Responsable du traitement</h2>
              <p className="text-body text-gray-700 mb-4">
                IL TRULLO est responsable du traitement de vos données personnelles.
              </p>

              <h2 className="heading-lg mt-8 mb-4">Finalité du traitement</h2>
              <p className="text-body text-gray-700 mb-4">
                Vos données sont traitées pour :
              </p>
              <ul className="list-disc pl-6 text-body text-gray-700 mb-4 space-y-2">
                <li>La gestion de vos commandes</li>
                <li>Le traitement de vos demandes de contact</li>
                <li>L'amélioration de nos services</li>
              </ul>

              <h2 className="heading-lg mt-8 mb-4">Durée de conservation</h2>
              <p className="text-body text-gray-700 mb-4">
                Vos données sont conservées pendant la durée nécessaire aux finalités pour lesquelles elles ont été collectées.
              </p>

              <h2 className="heading-lg mt-8 mb-4">Vos droits</h2>
              <p className="text-body text-gray-700 mb-4">
                Vous disposez des droits suivants :
              </p>
              <ul className="list-disc pl-6 text-body text-gray-700 mb-4 space-y-2">
                <li>Droit d'accès à vos données</li>
                <li>Droit de rectification</li>
                <li>Droit à l'effacement</li>
                <li>Droit d'opposition</li>
                <li>Droit à la portabilité</li>
              </ul>

              <h2 className="heading-lg mt-8 mb-4">Exercer vos droits</h2>
              <p className="text-body text-gray-700 mb-4">
                Pour exercer vos droits, contactez-nous par téléphone au +33 9 78 80 26 23 ou en boutique.
              </p>
            </div>
          </div>
        </section>
      </div>
    </main>
  );
};

export default RGPD;